<template lang="html">
  <div class="box">
    <ul>
      <li>
        <span></span>
        <div class="title">Video sharing platform (Front End)</div>
        <div class="info">
          <div class="project-description">
            <p class="text">
              Build the front end application on VueJS.
            </p>
          </div>
          <table class="project-details">
            <tr>
              <th>Role:</th>
              <td>Front End Engineer (Team leader)</td>
            </tr>
            <tr>
              <th>Team size:</th>
              <td>3-6</td>
            </tr>
          </table>
        </div>
        <div class="time">
          <span>Jun 2019</span>
          <span>Oct 2018</span>
        </div>
      </li>
      <li>
        <span></span>
        <div class="title">Video sharing platform (Back End)</div>
        <div class="info">
          <div class="project-description">
            <p class="text">
              A video social network (likes Youtube) using <a href="https://uiza.io" target="_blank">Uiza</a> SDK.
              Back end server was developed on Ruby on Rails.
            </p>
          </div>
          <table class="project-details">
            <tr>
              <th>Role:</th>
              <td>Ruby developer</td>
            </tr>
            <tr>
              <th>Team size:</th>
              <td>4</td>
            </tr>
          </table>
        </div>
        <div class="time">
          <span>Oct 2018</span>
          <span>Aug 2018</span>
        </div>
      </li>
      <li>
        <span></span>
        <div class="title">Kyorisoku</div>
        <div class="info">
          <div class="project-description">
            <a href="https://www.mapion.co.jp/" target="_blank">
              <img class="thumb" src="@/assets/img/kyorisoku.png" alt="Mapion Logo">
            </a>
            <p class="text">
              Rebuild a map and mesurement for <a target="_blank" href="https://www.mapion.co.jp/">mapion.co.jp</a>.<br>
              Developed on VueJS, LeafletJS and Ruby on Rails.
            </p>
          </div>
          <table class="project-details">
            <tr>
              <th>Role:</th>
              <td>Front End Engineer (Team leader)</td>
            </tr>
            <tr>
              <th>Team size:</th>
              <td>2</td>
            </tr>
          </table>
        </div>
        <div class="time">
          <span>Jun 2018</span>
          <span>Jan 2018</span>
        </div>
      </li>
      <li>
        <span></span>
        <div class="title">Mapion Web Maintenance</div>
        <div class="info">
          <div class="project-description">
            <a href="https://www.mapion.co.jp/" target="_blank">
              <img class="thumb" src="@/assets/img/mapion.png" alt="Mapion Logo">
            </a>
            <p class="text">
              Maintain the website <a target="_blank" href="https://www.mapion.co.jp/">mapion.co.jp</a><br>
              It is map and weather services from Mapion, developed on Ruby and Mayaa.
            </p>
          </div>
          <table class="project-details">
            <tr>
              <th>Role:</th>
              <td>Ruby Developer (Team leader)</td>
            </tr>
            <tr>
              <th>Team size:</th>
              <td>2</td>
            </tr>
          </table>
        </div>
        <div class="time">
          <span>Dec 2017</span>
          <span>Jun 2017</span>
        </div>
      </li>
      <li>
        <span></span>
        <div class="title">Aruku& Ranking Event</div>
        <div class="info">
          <div class="project-description">
            <img class="thumb" src="@/assets/img/arukuto_app_logo.jpg" alt="Aruku& Logo">
            <p class="text">Develop a new feature for <a target="_blank" href="https://apps.apple.com/JP/app/id1165290449?mt=8">aruku&</a> - ranking event. Rank players in order of points by seasons.</p>
          </div>
          <table class="project-details">
            <tr>
              <th>Role:</th>
              <td>Ruby Developer (Team leader)</td>
            </tr>
            <tr>
              <th>Team size:</th>
              <td>3</td>
            </tr>
          </table>
        </div>
        <div class="time">
          <span>Aug 2017</span>
          <span>Jun 2017</span>
        </div>
      </li>
      <li>
        <span></span>
        <div class="title">Aruku& Column</div>
        <div class="info">
          <div class="project-description">
            <img class="thumb" src="@/assets/img/arukuto_app_logo.jpg" alt="Aruku& Logo">
            <p class="text">Develop column feature and push notification for <a target="_blank" href="https://apps.apple.com/JP/app/id1165290449?mt=8">aruku&</a> application.</p>
          </div>
          <table class="project-details">
            <tr>
              <th>Role:</th>
              <td>Ruby Developer</td>
            </tr>
            <tr>
              <th>Team size:</th>
              <td>4-6</td>
            </tr>
          </table>
        </div>
        <div class="time">
          <span>Jun 2017</span>
          <span>Mar 2017</span>
        </div>
      </li>
      <li>
        <span></span>
        <div class="title">Aruku& CoTenant</div>
        <div class="info">
          <div class="project-description">
            <img class="thumb" src="@/assets/img/arukuto_app_logo.jpg" alt="Aruku& Logo">
            <p class="text">Develop the admin page for <a target="_blank" href="https://apps.apple.com/JP/app/id1165290449?mt=8">aruku&</a>'s custommers, using multi-tenant and subdomain.</p>
          </div>
          <table class="project-details">
            <tr>
              <th>Role:</th>
              <td>Ruby Developer</td>
            </tr>
            <tr>
              <th>Team size:</th>
              <td>4-6</td>
            </tr>
          </table>
        </div>
        <div class="time">
          <span>Mar 2017</span>
          <span>Dec 2016</span>
        </div>
      </li>
      <li>
        <span></span>
        <div class="title">Aruku& API</div>
        <div class="info">
          <div class="project-description">
            <img class="thumb" src="@/assets/img/arukuto_app_logo.jpg" alt="Aruku& Logo">
            <p class="text">Write API and Spec for <a target="_blank" href="https://apps.apple.com/JP/app/id1165290449?mt=8">aruku&</a>, it is an earn prize for walking application in Japan.</p>
          </div>
          <table class="project-details">
            <tr>
              <th>Role:</th>
              <td>Ruby Developer</td>
            </tr>
            <tr>
              <th>Team size:</th>
              <td>6-10</td>
            </tr>
          </table>
        </div>
        <div class="time">
          <span>Jan 2017</span>
          <span>Dec 2016</span>
        </div>
      </li>
      <div class="arrow" id="btn1" @click="scrollToTop">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 284.929 284.929" style="enable-background:new 0 0 284.929 284.929;" xml:space="preserve">
          <g>
            <g>
              <path d="M135.899,167.877c1.902,1.902,4.093,2.851,6.567,2.851s4.661-0.948,6.562-2.851L282.082,34.829    c1.902-1.903,2.847-4.093,2.847-6.567s-0.951-4.665-2.847-6.567L267.808,7.417c-1.902-1.903-4.093-2.853-6.57-2.853    c-2.471,0-4.661,0.95-6.563,2.853L142.466,119.622L30.262,7.417c-1.903-1.903-4.093-2.853-6.567-2.853    c-2.475,0-4.665,0.95-6.567,2.853L2.856,21.695C0.95,23.597,0,25.784,0,28.262c0,2.478,0.953,4.665,2.856,6.567L135.899,167.877z" fill="#FFFFFF"/>
              <path d="M267.808,117.053c-1.902-1.903-4.093-2.853-6.57-2.853c-2.471,0-4.661,0.95-6.563,2.853L142.466,229.257L30.262,117.05    c-1.903-1.903-4.093-2.853-6.567-2.853c-2.475,0-4.665,0.95-6.567,2.853L2.856,131.327C0.95,133.23,0,135.42,0,137.893    c0,2.474,0.953,4.665,2.856,6.57l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854l133.054-133.046    c1.902-1.903,2.847-4.093,2.847-6.565c0-2.474-0.951-4.661-2.847-6.567L267.808,117.053z" fill="#FFFFFF"/>
            </g>
          </g>
        </svg>
      </div>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Timeline',

  methods: {
    scrollToTop () {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home/Timeline.vue